export default __webpack_public_path__ + "static/media/about us page_Simplicity.df0d4ae1.png";